import forOwn from 'mout/object/forOwn'
/**
 * Filter items or sets by a given property
 * @param {object} items Object giving items or sets to filter 
 * @param {string} prop The property that is being considered  
 * @param {string} text The text to look for in the property
 * @param {object} activeItems An object with ID's and booleans for items that should be included in results no matter what
 */
export default function filterItemsBy (items, prop, text, activeItems) {
  let output = {}
  forOwn(items, (val, key, o) => {
    if (val[prop]) {
      if (val[prop].toLowerCase().search(text.toLowerCase()) !== -1 || activeItems[key]) {
        output[key] = val
      }
    } else if (!val[prop] && activeItems[key]) {
      output[key] = val
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/filterItemsBy.js